import React from 'react';
import '../less/main.less';
import {ReactSVG} from 'react-svg';
import tooltipIcon from '../img/tooltip_icon.svg';
import triangleIcon from '../img/triangle_icon.svg';
import DOMPurify from 'utils/sanitize';

export default function template() {
    const {children} = this.props;
    const {visible, popupOffsetX} = this.state;

    return (
      <span
        className={`tooltip-new${visible ? ' tooltip-new_open' : ''}`}
        ref={this.wrapperRef}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleClick}
      >
        <ReactSVG src={tooltipIcon} className='tooltip-new__icon' />
        <ReactSVG src={triangleIcon} className='tooltip-new__arrow' />
        <span
          ref={this.popupRef}
          className='tooltip-new__popup'
          style={{transform: `translate(calc(-50% + ${popupOffsetX}px), 0)`}}
          dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n(children))}}
        >
        </span>
      </span>
    );
}
